import React from 'react'
import Nav from "../components/Nav/nav";
import Whatsapp from '../Whatsapp/whatsapp';
import GroDash from "../components/GeneralRegisterOfficer/groadmin/dashboard"

const GroAdminDash = () => {
  return (
    <div>
      <Nav />
     <GroDash/>
     <Whatsapp/>
    </div>
  )
}

export default GroAdminDash